"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStandardSQLCompletionProvider = void 0;
const types_1 = require("../types");
const macros_1 = require("./macros");
function getStandardSQLCompletionProvider(monaco, language) {
    var _a, _b, _c;
    const provider = { triggerCharacters: ['.', ' ', '$', ',', '(', "'"] };
    if (language && Array.isArray(language.builtinFunctions)) {
        provider.supportedFunctions = () => language.builtinFunctions.map((f) => ({ id: f, name: f }));
    }
    const operators = [];
    if ((_a = language === null || language === void 0 ? void 0 : language.comparisonOperators) === null || _a === void 0 ? void 0 : _a.length) {
        operators.push(...language.comparisonOperators.map((f) => ({
            id: f.toLocaleLowerCase(),
            operator: f,
            type: types_1.OperatorType.Comparison,
        })));
    }
    // some languages in the monaco language registry don't specify logical operators, only operators. if so, suggest them instead
    language.logicalOperators = (_b = language.logicalOperators) !== null && _b !== void 0 ? _b : language.operators;
    if ((_c = language === null || language === void 0 ? void 0 : language.logicalOperators) === null || _c === void 0 ? void 0 : _c.length) {
        operators.push(...language.logicalOperators.map((f) => ({ id: f.toLocaleLowerCase(), operator: f, type: types_1.OperatorType.Logical })));
    }
    provider.supportedOperators = () => operators;
    provider.supportedMacros = () => macros_1.MACROS;
    return provider;
}
exports.getStandardSQLCompletionProvider = getStandardSQLCompletionProvider;
//# sourceMappingURL=standardSQLCompletionItemProvider.js.map